<template>
  <component
    :is="resolvedIcon"
    v-if="resolvedIcon"
    class="shrink-0"
    :class="sizeClass"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { icons } from '@/utils/iconRegistry'

type Size = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'

interface Props {
  icon: string
  size?: Size
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md'
})

const path = computed(
  () => `../assets/icons/${props.icon}.svg`
)

const resolvedIcon = computed(
  () => icons[path.value] ?? null
)

const sizeMap: Record<Size, string> = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-10 h-10',
  '2xl': 'w-12 h-12',
  '3xl': 'w-[60px] h-[60px]'
}

const sizeClass = computed(
  () => sizeMap[props.size]
)
</script>
